(() => {
  'use strict';
  const count = value => { const match = String(value || '').replace(/[.,]/g, '').match(/^\s*(\d+)/); return match ? Number(match[1]) : 0; };
  const rate = balls => balls > 0 && balls <= 500 ? Math.ceil(balls / 100) * 895 : null;
  const money = cents => new Intl.NumberFormat('nl-NL', {style:'currency',currency:'EUR'}).format(cents / 100);
  function quoteUrl(details, balls) {
    const url = new URL((window.Shopify?.routes?.root || '/') + 'pages/contact', location.origin);
    url.searchParams.set('offerte', '1'); url.searchParams.set('aantal', String(balls));
    url.searchParams.set('aanvraag', details); url.hash = 'KerstbalContact'; return url.href;
  }
  function init(layout) {
    if (layout.dataset.deliveryReady) return; layout.dataset.deliveryReady = 'true';
    const form = layout.querySelector('.product-form'), note = layout.querySelector('[data-kb-delivery-note]');
    if (!form || !note) return;
    const buy = form.querySelector('[name="add"]'), quote = form.querySelector('[data-kb-product-quote]');
    const index = Number(layout.dataset.kbCountIndex);
    function selection() {
      const variants = JSON.parse(layout.querySelector('[data-kb-variant-json]')?.textContent || '[]');
      const selected = variants.find(v => String(v.id) === form.querySelector('[name="id"]')?.value);
      const amount = index >= 0 ? count(selected?.options[index]) : 1;
      const quantity = document.querySelector('[name="quantity"][form="' + form.id + '"]') || form.querySelector('[name="quantity"]');
      return {selected, balls: amount * Number(quantity?.value || 1)};
    }
    function sync() {
      const {selected,balls} = selection();
      const large = balls > 500;
      buy.hidden = large; quote.hidden = !large;
      const summary = layout.querySelector('[data-kb-order-summary]');
      const unit = layout.querySelector('[data-kb-unit-price]');
      if (summary) summary.hidden = large;
      if (unit) unit.hidden = large;
      const price = document.getElementById(form.querySelector('[data-kb-variants]')?.dataset.priceTarget);
      if (price && selected) price.textContent = large ? 'Prijs op offerte' : selected.price;
      if (large) {
        note.textContent = 'Meer dan 500 ballen? Vraag een offerte inclusief passend vervoer aan. Je rekent nog niet af. Je ontwerp kun je bij de offerte verder met ons afstemmen.';
        quote.href = quoteUrl('Offerte voor ' + layout.dataset.kbProductTitle + '\nKeuze: ' + (selected?.title || '') + '\nAantal ballen: ' + balls + '\n\nAfleveradres / postcode:\nGewenste ontvangstdatum:\nOntwerp en verdere wensen:', balls);
      } else {
        note.textContent = (rate(balls) === null ? '' : 'Verzending naar Nederland voor deze keuze: ' + money(rate(balls)) + '. ') + '€ 8,95 per begonnen 100 ballen in de hele winkelwagen. Tot en met 500 direct bestellen; daarboven een offerte. Ophalen in Rosmalen op afspraak.';
      }
    }
    form.addEventListener('submit', event => {
      if (selection().balls > 500) {event.preventDefault();event.stopImmediatePropagation();sync();location.assign(quote.href);}
    }, true);
    document.addEventListener('change', event => { if (layout.contains(event.target)) sync(); });
    layout.addEventListener('input', sync);
    layout.addEventListener('kb:variants-ready', sync);
    sync();
  }
  function boot() {
    document.querySelectorAll('.product-layout').forEach(init);
    const form = document.getElementById('KerstbalContact');
    const params = new URLSearchParams(location.search);
    if (form && params.get('offerte') === '1' && !form.dataset.quoteReady) {
      form.dataset.quoteReady = 'true';
      const body=form.querySelector('[name="contact[body]"]'), amount=form.querySelector('[name="contact[aantal]"]');
      if (body && !body.value.trim()) body.value=(params.get('aanvraag') || 'Ik ontvang graag een offerte inclusief transport.').slice(0,15000);
      if (amount && !amount.value) amount.value=String(count(params.get('aantal')) || '');
      const title=document.querySelector('.kb-contact-panel h2');if(title)title.textContent='Vraag je offerte inclusief transport aan';
    }
    const cartQuote=document.querySelector('[data-kb-cart-quote]');
    if(cartQuote){const details=document.querySelector('[data-kb-cart-quote-details]');cartQuote.href=quoteUrl(details?.textContent.trim() || '',Number(cartQuote.dataset.balls));}
  }
  window.KBDelivery={count,rate};
  boot();document.addEventListener('shopify:section:load',boot);
})();
